import React from "react";
import { ISVG } from "./interface";

const SVG: React.FC<ISVG> = () => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_32568_1673)">
      <path
        d="M10.9971 11.0936C10.731 11.0936 10.4759 10.9879 10.2878 10.7998C10.0996 10.6117 9.99395 10.3565 9.99395 10.0905V7.09047C9.98044 6.95122 9.9962 6.81069 10.0402 6.6779C10.0843 6.54511 10.1556 6.42299 10.2496 6.3194C10.3436 6.21581 10.4583 6.13303 10.5862 6.07639C10.7141 6.01974 10.8525 5.99048 10.9924 5.99048C11.1323 5.99048 11.2706 6.01974 11.3986 6.07639C11.5265 6.13303 11.6411 6.21581 11.7352 6.3194C11.8292 6.42299 11.9005 6.54511 11.9445 6.6779C11.9886 6.81069 12.0043 6.95122 11.9908 7.09047V10.0905C11.9908 10.3549 11.8864 10.6086 11.7003 10.7965C11.5142 10.9843 11.2615 11.0911 10.9971 11.0936Z"
        fill="var(--tlx-cta-primary-default)"
      />
      <path
        d="M15.0002 11.0936C14.7341 11.0936 14.479 10.9879 14.2909 10.7998C14.1028 10.6116 13.9971 10.3565 13.9971 10.0904V6.09669C14.0211 5.84858 14.1367 5.61832 14.3213 5.45078C14.5059 5.28324 14.7462 5.19043 14.9955 5.19043C15.2448 5.19043 15.4851 5.28324 15.6697 5.45078C15.8543 5.61832 15.9699 5.84858 15.9939 6.09669V10.0998C15.9915 10.3626 15.886 10.614 15.7002 10.7998C15.5143 10.9856 15.263 11.0911 15.0002 11.0936Z"
        fill="var(--tlx-cta-primary-default)"
      />
      <path
        d="M19.0029 11.0937C18.7369 11.0937 18.4817 10.9881 18.2936 10.7999C18.1055 10.6118 17.9998 10.3567 17.9998 10.0906V4.09999C17.9863 3.96074 18.0021 3.82021 18.0461 3.68742C18.0901 3.55463 18.1614 3.43251 18.2555 3.32892C18.3495 3.22533 18.4641 3.14256 18.5921 3.08591C18.72 3.02926 18.8583 3 18.9982 3C19.1381 3 19.2765 3.02926 19.4044 3.08591C19.5323 3.14256 19.647 3.22533 19.741 3.32892C19.835 3.43251 19.9064 3.55463 19.9504 3.68742C19.9944 3.82021 20.0102 3.96074 19.9967 4.09999V10.1C19.9942 10.3628 19.8888 10.6141 19.7029 10.8C19.5171 10.9858 19.2657 11.0913 19.0029 11.0937Z"
        fill="var(--tlx-cta-primary-default)"
      />
      <path
        d="M22.9969 30H7.00313C5.94144 30 4.92323 29.5782 4.17249 28.8275C3.42176 28.0768 3.00001 27.0586 3.00001 25.9969V7.875C2.99887 7.14136 3.1596 6.4165 3.47073 5.7521C3.78186 5.0877 4.23574 4.50012 4.80001 4.03125L8.25001 1.1625C9.14768 0.414436 10.2784 0.00327453 11.4469 0L22.9969 0C24.0586 0 25.0768 0.421757 25.8275 1.17249C26.5782 1.92322 27 2.94143 27 4.00313V25.9969C27 27.0586 26.5782 28.0768 25.8275 28.8275C25.0768 29.5782 24.0586 30 22.9969 30ZM11.4469 1.99688C10.7611 2.0077 10.0996 2.25246 9.57188 2.69062L6.07501 5.56875C5.73669 5.85017 5.46465 6.20278 5.27829 6.60143C5.09193 7.00008 4.99584 7.43494 4.99688 7.875V25.9969C4.99935 26.5257 5.21052 27.0322 5.58448 27.4062C5.95843 27.7801 6.46491 27.9913 6.99376 27.9938H22.9969C23.5257 27.9913 24.0322 27.7801 24.4062 27.4062C24.7801 27.0322 24.9913 26.5257 24.9938 25.9969V4.00313C24.9913 3.47428 24.7801 2.9678 24.4062 2.59385C24.0322 2.21989 23.5257 2.00872 22.9969 2.00625L11.4469 1.99688Z"
        fill="var(--tlx-cta-primary-default)"
        stroke="var(--tlx-stroke-border-default)"
        strokeWidth="0.8"
      />
      <path
        d="M20 20.8753C20 24.0003 17.8125 25.5628 15.2125 26.469C15.0764 26.5152 14.9285 26.513 14.7938 26.4628C12.1875 25.5628 10 24.0003 10 20.8753V16.5003C10 16.3345 10.0658 16.1755 10.1831 16.0583C10.3003 15.9411 10.4592 15.8753 10.625 15.8753C11.875 15.8753 13.4375 15.1253 14.525 14.1753C14.6574 14.0622 14.8258 14 15 14C15.1742 14 15.3426 14.0622 15.475 14.1753C16.5688 15.1315 18.125 15.8753 19.375 15.8753C19.5408 15.8753 19.6997 15.9411 19.8169 16.0583C19.9342 16.1755 20 16.3345 20 16.5003V20.8753Z"
        stroke="var(--tlx-cta-primary-default)"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.125 20.2505L14.375 21.5005L16.875 19.0005"
        stroke="var(--tlx-cta-primary-default)"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_32568_1673">
        <rect width="30" height="30" fill="var(--tlx-surface-bg-surface)" />
      </clipPath>
    </defs>
  </svg>
);

export default SVG;
